import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { ListItem } from "@website/ui/list-item";
import { Popover } from "@website/ui/popover";
import { getChatbotVisibilityState } from "@website/widget/chat-bot";
import { numberConvert } from "@website/utils/number-convert";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { useChatBotNavigation } from "@website/widget/chat-bot/navigation";
import { trackChatbotIconClicked } from "@website/widget/chat-bot/tracking";
export function SupportAgent() {
  const $ = _c(18);
  const chatBotNavigation = useChatBotNavigation();
  const [supportMenuIsOpen, toggleSupportMenu] = useToggle(false);
  let t0;
  if ($[0] !== chatBotNavigation || $[1] !== toggleSupportMenu) {
    t0 = () => {
      const showChatbot = getChatbotVisibilityState();
      if (!showChatbot) {
        toggleSupportMenu();
        return;
      }
      trackChatbotIconClicked("support_call");
      chatBotNavigation.toggle();
    };
    $[0] = chatBotNavigation;
    $[1] = toggleSupportMenu;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleSupportClick = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon name="support_agent" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== handleSupportClick) {
    t2 = <Button StartIcon={t1} aria-label={"\u0646\u0645\u0627\u06CC\u0634 \u0644\u06CC\u0646\u06A9 \u0647\u0627\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} className="!mx-0 max-xl:!hidden" color="neutral" onClick={handleSupportClick} role="button" variant="text">پشتیبانی</Button>;
    $[4] = handleSupportClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon name="support_agent" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleSupportClick) {
    t4 = <Button EndIcon={t3} className="!mx-0 xl:!hidden" color="neutral" equalDimension={true} onClick={handleSupportClick} variant="text" />;
    $[7] = handleSupportClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon name="support_agent" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-[312px] rounded-lg py-2"><ListItem StartIcon={t5} aria-label={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} href="tel:+982192000123" role="link" subtitle={<div className="text-end" style={{
        direction: "ltr"
      }}>{numberConvert("+98 21 92000123", {
          locale: "fa"
        })}</div>} title={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} /></div>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== supportMenuIsOpen || $[12] !== toggleSupportMenu) {
    t7 = <Popover gap="16px" horizontalPosition="end" onClose={toggleSupportMenu} open={supportMenuIsOpen}>{t6}</Popover>;
    $[11] = supportMenuIsOpen;
    $[12] = toggleSupportMenu;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t7) {
    t8 = <div className="relative">{t2}{t4}{t7}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}